import { render, staticRenderFns } from "./MiscSectionItem.vue?vue&type=template&id=b5fda340&scoped=true"
import script from "./MiscSectionItem.vue?vue&type=script&lang=js"
export * from "./MiscSectionItem.vue?vue&type=script&lang=js"
import style0 from "./MiscSectionItem.vue?vue&type=style&index=0&id=b5fda340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fda340",
  null
  
)

export default component.exports